module.exports = __webpack_public_path__ + "img/21-Women’s Health.e8508611.png";